import { Routes } from '@angular/router';
import { NewUserComponent } from "./domain/login/new-user-component/new-user.component";
import { EntranceComponent } from "./domain/entrance/component/base/entrance.component";
import { AuthGuard } from "./util/guards/login.guard";
import {
  OrganizationSettingsComponent,
} from "./domain/organization/component/organization-settings/organization-settings.component";
import { CabinetComponent } from "./domain/cabinet/component/cabinet/cabinet.component";
import { FRONT_URLS, MODELS_URLS } from "./util/common/url-parts";
import { MaintenanceComponent } from "./core/component/maintenance/maintenance.component";
import { TermsAndConditionsComponent } from "./core/component/terms-and-conditions/terms-and-conditions.component";
import { CountryGuard } from "./util/guards/country.guard";
import { BanComponent } from "./core/component/ban/ban.component";
import { ModelsPageComponent } from "./domain/models/base-page/models-page.component";
import { BudgetModelComponent } from "./domain/models/budget-model/budget-model.component";
import { FundStrategyComponent } from "./domain/models/fund-strategy/fund-strategy.component";

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: FRONT_URLS.LOGIN },
  {
    path: FRONT_URLS.LOGIN,
    loadChildren: () => import('./domain/login/login.routes')
      .then((m) => m.loginRoutes),
  },
  { path: FRONT_URLS.MAINTENANCE, component: MaintenanceComponent },
  { path: FRONT_URLS.TERMS_AND_CONDITIONS, component: TermsAndConditionsComponent },
  { path: FRONT_URLS.BAN, component: BanComponent },
  {
    path: FRONT_URLS.COMPLETE_REGISTRATION,
    canActivate: [AuthGuard, CountryGuard],
    component: NewUserComponent,
  },
  {
    path: FRONT_URLS.ENTRANCE,
    canActivate: [AuthGuard, CountryGuard],
    component: EntranceComponent,
  },
  {
    path: FRONT_URLS.ORG_SETTINGS,
    canActivate: [AuthGuard],
    component: OrganizationSettingsComponent,
  },
  {
    path: FRONT_URLS.CABINET,
    canActivate: [AuthGuard],
    component: CabinetComponent,
  },
  {
    path: MODELS_URLS.BASE,
    canActivate: [AuthGuard],
    component: ModelsPageComponent,
    children: [
      {path: '', redirectTo: MODELS_URLS.FUND_BUDGET, pathMatch: 'full' },
      {path: MODELS_URLS.FUND_BUDGET , component: BudgetModelComponent },
      {path: MODELS_URLS.INVESTMENT , component: FundStrategyComponent },
    ]
  },
];
